enum TextTemplateType {
    Comment = 1,
    Conclusion = 2,
    Description = 3
}

export default TextTemplateType;